import { Injectable } from '@angular/core';

declare var $;

@Injectable({
  providedIn: 'root'
})
export class ScrollControlService {

  loaded: boolean = false;

  constructor() { }

  toTop() {
    if (this.loaded)
      $("html, body").animate({ scrollTop: 0 }, "slow");
  }

}
